export default function ProfileIcon24() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 20L12 14M12 14L15 20M12 14V10M6 8L12 10M12 10L18 8M13 5C13 5.5523 12.5523 6 12 6C11.4477 6 11 5.5523 11 5C11 4.4477 11.4477 4 12 4C12.5523 4 13 4.4477 13 5Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
